import React, { useEffect, useState, useMemo } from 'react';
import logo_red from '../assets/images/logo/chronos_RED_logo_CMYK.svg';
import CytoscapeComponent from "react-cytoscapejs";
import Graph from './Graph';
import axios from 'axios';
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';
import SearchBar from "../components/search/SearchBar"
import SearchSuggestion from "../components/search/SearchSuggestion"
import ScrollableBox from "../components/widget/ScrollableBox"
import * as searchSuggestion from '../hooks/search/searchSuggestion';
import * as keyBrowse from '../hooks/search/keyBrowse';
import * as search from '../hooks/search/search';
import SplitPane from "react-split-pane"
import '../assets/css/pane.css';
import NodeInfoState from '../data/NodeInfoState';
import InfoPane from '../components/pane/InfoPane';
import GraphSidebar from '../components/sidebar/GraphSidebar';
import SidebarState from '../data/SidebarState';
import Tooltip from '../components/widget/Tooltip';

const StartingPage = ({logout}) => {
    const [vertices, setVertices] = useState([]);
    const [searchVertices, setSearchVertices] = useState([]); //Vertices used to form search suggestions
    const [edges, setEdges] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const num_search_suggestions = 10
    const [searchResults, setSearchResults] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(true);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [sidebarState, setSidebarState] = useState(SidebarState.HIDDEN);
    const [nodeInfoState, setNodeInfoState] = useState(NodeInfoState.HIDDEN); //HIDDEN
    const [nodeInfo, setNodeInfo] = useState(null);
   
    //for sidebar
    //{id: item, val: capitalizeFirstLetter(item)}

    const [graphName, setGraphName] = useState(null)
    const [trees, setTrees] = useState([]) //The trees available for the graph
    const graphNames = [{id: "kommune_graph", val: "Kommune Graph"}, {id: "common_graph", val: "Common Graph"}]
    const defaultGraph = "kommune_graph"
    //MEMOS
    const { treeCount, nodeCount } = useMemo(() => {
        let treeCount = 0;
        let nodeCount = 0;
    
        vertices.forEach(({ classes }) => {
          if (classes.includes("tree")) {
            treeCount++;
          } else if (classes.includes("node")) {
            nodeCount++;
          }
        });
    
        return { treeCount, nodeCount };
      }, [vertices]);

      const { parentedVerteces } = useMemo(() => {
        if (!edges || edges.length === 0) {
            return { parentedVerteces: [] }; // Return an object with an empty array
        }
    
        return {
            parentedVerteces: edges
                .filter(edge => !edge.classes.includes("cross-link")) 
                .map(edge => edge.data.target),
        };
    }, [edges]);

    const reset_nodeinfo = () => {
        if (NodeInfoState !== NodeInfoState.HIDDEN) {
            setNodeInfoState(NodeInfoState.HIDDEN)
            setNodeInfo(null)
            setSidebarState(SidebarState.HIDDEN)
        }
        
    }


    const hide_subtree = (vertexId) => {    
        // Step 1: Create a Set to store vertices to remove
        const toRemove = new Set();
        toRemove.add(vertexId); // Start with the root node
    
        // Step 2: Find the tree the vertex belongs to
        const treeName = vertices.find(v => v.data.id === vertexId)?.data.tree;
        
        if (!treeName) return; // If the vertex is not found, exit early
    
        // Step 3: Recursively find all descendants
        const findDescendants = (id) => {
            edges.forEach(edge => {
                if (edge.data.source === id && !toRemove.has(edge.data.target)) {
                    toRemove.add(edge.data.target);
                    findDescendants(edge.data.target);
                }
            });
        };
    
        findDescendants(vertexId);
    
        // Step 4: Filter vertices and edges
        let newVertices = vertices.filter(vertex => !toRemove.has(vertex.data.id));
        const newEdges = edges.filter(edge => 
            !toRemove.has(edge.data.source) && !toRemove.has(edge.data.target)
        );
    
        // Step 5: Check if there are any nodes left in the tree
        const treeStillHasNodes = newVertices.some(vertex => vertex.data.tree === treeName && vertex.classes !== "tree");
    
        // Step 6: If no nodes remain, remove the "tree" entry
        if (!treeStillHasNodes) {
            newVertices = newVertices.filter(vertex => !(vertex.classes === "tree" && vertex.data.tree === treeName));
        }
    
        // Step 7: Update state with new lists
        setVertices(newVertices);
        setEdges(newEdges);
    };
    


    const clear_search = () => {
        //set grouping_label after clearing search
        /*if (!toggleAttributes.includes(groupingLabel)) {
            setGroupingLabel(dataset_specific_data[dataset]["default_label"])
        }
        */
        search.clear_search(setSearchValue)
    }

    /*const show_clear_btn = (id) => {
        var clear_btn = document.getElementById((id + "_clear"));
        clear_btn.style.display = "flex";
    }*/

    const showLogoutButton = false

    const appendVertices = (newVertices) => {
        setVertices(prevVertices => {
            const existingIds = new Set(prevVertices.map(v => v.data.id.toString())); // Track existing vertex IDs
            newVertices = newVertices.filter(v => !existingIds.has(v.data.id.toString())); // Filter unique

            return newVertices.length > 0 ? [...prevVertices, ...newVertices] : prevVertices; // Update only if there's new data
        });
    } 

    const appendEdges = (newEdges) => {
        setEdges(prevEdges => {
            const existingEdgeIds = new Set(prevEdges.map(e => e.data.id.toString())); // Track existing edge IDs
            newEdges = newEdges.filter(e => !existingEdgeIds.has(e.data.id.toString())); // Filter unique
            return newEdges.length > 0 ? [...prevEdges, ...newEdges] : prevEdges; // Update only if there's new data
        });
        console.log("edges..")
    } 


    const api_switch_graph = (newGraphName) => {
        if (newGraphName !== graphName) {
            setDataLoaded(false)

            let params = {
                graph_name: newGraphName,
            };
    
            axios.get('/api/switch_graph', { params })
            .then(response => {
                setVertices([])
                setEdges([])
                setGraphName(response.data.graph_name)
                setSearchVertices(response.data.vertices)
                setTrees(response.data.trees)
                //appendVertices(response.data.vertices)
            })
            .catch(error => {
                console.error('There was an error when switching graph!', error);
        
                let msg = error.response.data.error
                Swal.fire({
                    icon: 'error',
                    title: 'Error!.',
                    text: msg,
                });
            })
            .finally(() => {
                if (dataLoaded) {setDataLoaded(true)}
            });
        }
        //setGraphName(newGraphName)
    }

    const api_get_tree = (tree) => {
        setDataLoaded(false)

        let params = {
            tree: tree,
        };

        axios.get('/api/get_tree', { params })
        .then(response => {
            appendVertices(response.data.vertices)
            appendEdges(response.data.edges)
        })
        .catch(error => {
            console.error('There was an error when getting tree!', error);
    
            let msg = error.response.data.error
            Swal.fire({
                icon: 'error',
                title: 'Error!.',
                text: msg,
            });
        })
        .finally(() => {
            if (dataLoaded) {setDataLoaded(true)}
        });
    }

    const get_node_by_id = (id) => {
        let params = {
            id: id,
        };

        axios.get('/api/get_node_by_id', { params })
        .then(response => {
            appendVertices(response.data.vertices)
        })
        .catch(error => {
            console.error('There was an error when fetching vertex by label!', error);
    
            let msg = error.response.data.error
            Swal.fire({
                icon: 'error',
                title: 'Error!.',
                text: msg,
            });
        })
        .finally(() => {
            if (dataLoaded) {setDataLoaded(true)}
        });
    }

    const get_connected_nodes = async (vertex_id, type) => {
        setDataLoaded(false)
        let params = { id: vertex_id, type: type };    
        try {
            const response = await axios.get('/api/get_connected_nodes', { params });
    
            appendVertices(response.data.vertices)    
            appendEdges(response.data.edges)
    
        } catch (error) {
            console.error('There was an error when fetching vertex by label!', error);
    
            let msg = error.response?.data?.error || "Unknown error occurred.";
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: msg,
            });
        }
        setDataLoaded(true)
    };

    const get_data = (subtree = null) => { 
        setDataLoaded(false)
        let params = { subtree: subtree};    
        if (vertices.length === 0 && edges.length === 0) {
            axios.get('/api/get_data', { params })
            .then(data => {
                appendVertices(data.data.vertices)
                appendEdges(data.data.edges)
            })
            .catch(error => {
                console.error('There was an error fetching data!', error);
                let msg = error.message || 'Unknown error'; // Use error message from the catch
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: msg,
                });
            })
            .finally(() => {
                setDataLoaded(true)
            });
        }
    };

    const get_node_info_detailed = (label, detailed="1") => {
        setSidebarState(SidebarState.NODEINFO)
        setNodeInfoState(NodeInfoState.LOADING)
        let params = {
            label: label,
            detailed: detailed
        };

        axios.get('/api/get_node_by_label', { params })
        .then(response => {
            if (response.data.vertices.length > 0 ) {
                setNodeInfo(response.data.vertices[0])
            }
        })
        .catch(error => {
            console.error('There was an error when fetching vertex by label!', error);
    
            let msg = error.response.data.error
            Swal.fire({
                icon: 'error',
                title: 'Error!.',
                text: msg,
            });
        })
        .finally(() => {
            setNodeInfoState(NodeInfoState.NODEINFO)
        });
    }

    /*const get_search_vertices = () => { 
        if (vertices.length === 0 && edges.length === 0) {
            axios.get('/api/get_all_vertices', {  })
            .then(data => {
                setSearchVertices(data.data.vertices)
            })
            .catch(error => {
                console.error('There was an error fetching data!', error);
                let msg = error.message || 'Unknown error'; // Use error message from the catch
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: msg,
                });
            })
            .finally(() => {
            });
        }
    };*/

    useEffect(() => {
        //get_node_by_label("HA");
        api_switch_graph(defaultGraph);
        window.addEventListener('keydown', keyBrowse.handleKeyDown);
        window.addEventListener('keyup', keyBrowse.handleKeyUp);
        window.addEventListener('keypress', keyBrowse.handleKeyEnter);
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []); 

    const handleSearchLoading = async () => {
        await search.handleSearch(searchVertices, setSearchValue, setDataLoaded, get_node_by_id);
    };

    const nodeIsParanted = (node) => {
        return parentedVerteces.some(v => v.toString() === node.id.toString()) || node.label === node.name //Parent is showing or is a root
        }

    const graph = React.useMemo(() => {
            if (!(vertices === null || vertices.length === 0)) {
                return <Graph 
                vertices={vertices} 
                edges={edges} 
                parentedVerteces={parentedVerteces} 
                get_connected_nodes={get_connected_nodes} 
                hide_subtree={hide_subtree} 
                get_node_info_detailed={get_node_info_detailed} 
                reset_nodeinfo={reset_nodeinfo}/>
            } else {
                return <div class="prologue-container"><span class="prologue-txt">Use search bar to insert nodes!</span></div>
            }
    }, [vertices, edges]);

    const spinner = React.useMemo(() => {
        if (!dataLoaded) {
            return (
                <div className="overlay">
                    <Spinner animation="border" variant="primary" className="scatter-spinner large"/>
                </div>
            );
        }
        return null;
    }, [dataLoaded]);

    

    
    return (
        <div className='flex-row main-container'>
        <GraphSidebar 
        graphName={graphName} 
        trees={trees}
        api_switch_graph={api_switch_graph} 
        api_get_tree={api_get_tree}
        graphNames={graphNames}
        treeCount={treeCount}
        nodeCount={nodeCount}
        nodeInfoState={nodeInfoState}
        nodeInfo={nodeInfo}
        sidebarState={sidebarState}
        setSidebarState={setSidebarState}
        get_connected_nodes={get_connected_nodes}
        hide_subtree={hide_subtree}
        nodeIsParanted={nodeIsParanted}/>
        <main className="dark-centered-background" style={{position: "absolute", width: "100%", height: "100%"}}>
            {spinner} {/* Spinner overlays everything */}
            {showLogoutButton && (
                <div role="button" id="startpage-logout-button" onClick={logout}>
                    Logout
                </div>
            )}
            <div className="graph-container">
                <span className="search-bar">
                    <SearchBar handleSearch={handleSearchLoading} clearAction={() => clear_search()} 
                        onChange={(e) => searchSuggestion.updateInputSuggestions(
                            e, searchVertices, setSearchResults, num_search_suggestions
                        )}
                    /> 
                    <ScrollableBox id="search_suggestions" track_color="#b4b4b4" thumb_color="#333436" 
                        thumb_hover_color="#54565a" width="324px" maxHeight="200px">
                        {searchResults.map((result, index) => (
                            <SearchSuggestion 
                                key={index} 
                                content={result.result} 
                                type={result.attribute} 
                                hover_color="#b4b4b4"
                                id={result.id}
                                name={result.name}
                                onClick={() => search.updateSearchBar(result.result)}
                            />
                        ))}
                    </ScrollableBox>   
                </span>
                {graph}
            </div>
        </main>
        <Tooltip/>
    </div>
  
    );
    
};

export default StartingPage;